import React, { useEffect } from 'react'
import { IonCard, IonCardContent, IonButton, IonText, IonRouterLink, IonLoading } from '@ionic/react'
import styled from 'styled-components'
import { Box, Colors, Input } from '../../atoms'
import { useSignIn } from '../../../modules/auth'
import { useFormik } from 'formik'
import { useMediaQuery } from 'react-responsive'

const StyledCard = styled(IonCard)`
  --background: white;
  border-radius: 12px;
  box-shadow: none;
  min-width: 720px;
  padding: 100px 196px;
`

const StyledIonButton = styled(IonButton)`
  --background: ${Colors.secondary.default};
  --color: white;
  --border-radius: 12px;
`

interface SendData {
  email: string
  password: string
}

export const Login = () => {
  const { isLoading, handleSignInWithEmailAndPassword } = useSignIn()

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validateOnChange: true,
    validateOnBlur: false,
    validate: values => {
      const errors: Partial<SendData> = {}
      if (!values.email) {
        errors.email = 'メールアドレスは必須です'
      }
      if (!values.password) {
        errors.password = 'パスワードは必須です'
      }
      return errors
    },
    onSubmit: values => {
      if (values.email && values.password) {
        handleSignInWithEmailAndPassword({ email: values.email.toString(), password: values.password.toString() })
      }
    }
  })
  const isSp = useMediaQuery({
    query: '(max-device-width: 500px)'
  })

  const { email, password } = formik.values

  // 2) 値の注入→検証→送信まで一括
  useEffect(() => {
    (window as any).nativeFillAndSubmitLogin = async (email: string, password: string) => {
      // 値をセット（触った扱いにしてバリデーションも走らせる）
      formik.setFieldValue("email", email, false);
      formik.setFieldTouched("email", true, false);
      formik.setFieldValue("password", password, false);
      formik.setFieldTouched("password", true, false);

const errs = await formik.validateForm({ email, password } as any);
    if (Object.keys(errs).length !== 0) {
      formik.setErrors(errs);
      return false;
    }
    await formik.submitForm();
    return true; // 成否を返す（API成功まで厳密に判定したいなら onSubmit 内で window.__nativeLoginResolve を使う拡張も可）
  };
  return () => { delete (window as any).nativeFillAndSubmitLogin; };
}, [formik]);

      // 最新の values で validate → OKなら submit
//      const errs = await formik.validateForm({
//        email,
//        password,
//      } as any);
//      if (Object.keys(errs).length === 0) {
//        await formik.submitForm();
//        return true;
//      } else {
//        // 必要ならエラーを画面に反映
//        formik.setErrors(errs);
//        return false;
//      }
//    };
//    return () => { delete (window as any).nativeFillAndSubmitLogin; };
//  }, [formik]);

  return (
    <>
      <IonLoading isOpen={isLoading} />
      <StyledCard>
        {isSp && (
          <Box mb="55px">
            <IonText color="primary">
              <h1 style={{ textAlign: 'center', fontSize: '22px' }}>Change the World College</h1>
            </IonText>
          </Box>
        )}
        <IonCardContent style={{ padding: '0px' }}>
          <form onSubmit={formik.handleSubmit}>
            <Box mb="32px">
              <Input
                name="email"
                type="email"
                placeholder="メールアドレス"
                required
                value={email}
                onIonChange={formik.handleChange}
              />
              <Box height={'16px'} />
              <Input
                name="password"
                type="password"
                placeholder="パスワード"
                required
                value={password}
                onIonChange={formik.handleChange}
              />
            </Box>

            <Box mt="16px" display="flex" justifyContent="center">
              <Box width="100%" mb="16px">
    <button
      type="submit"
      disabled={isLoading || !formik.isValid}
      style={{
        width: "100%",
        height: "44px",
        backgroundColor: "#000000",
        border: "none",
        borderRadius: "8px",
        color: "white",
        fontWeight: "bold",
        fontSize: "16px",
        cursor: isLoading || !formik.isValid ? "not-allowed" : "pointer",
        opacity: isLoading || !formik.isValid ? 0.5 : 1,
      }}
    >
      ログイン
    </button>
              </Box>
            </Box>
            <Box textAlign="center">
              <IonRouterLink routerLink="/password-reset" routerDirection="forward">
                <IonText>
                  <h5 style={{ color: Colors.secondary.default }}>パスワードを忘れた方へ</h5>
                </IonText>
              </IonRouterLink>
            </Box>
          </form>
          {isSp && (
            <Box display="flex" mb="100px" mt="16px">
              <IonRouterLink
                routerLink="term-of-service"
                routerDirection="forward"
                color="success"
                style={{
                  textDecoration: 'underline',
                  textAlign: 'center',
                  width: '100%',
                  fontSize: '12px',
                  lineHeight: '18px'
                }}
              >
                利用規約
              </IonRouterLink>
            </Box>
          )}
        </IonCardContent>
      </StyledCard>
    </>
  )
}
